export default function SectionHeading({
  eyebrow,
  title,
  description,
  center = false,
  light = false,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  center?: boolean;
  light?: boolean;
}) {
  return (
    <div className={center ? 'mx-auto mb-12 max-w-3xl text-center' : 'mb-10 max-w-3xl'}>
      {eyebrow ? (
        <p
          className={`mb-3 text-sm font-bold uppercase tracking-[0.18em] ${
            light ? 'text-green-300' : 'text-[#33b300]'
          }`}
        >
          {eyebrow}
        </p>
      ) : null}

      <h2
        className={`text-3xl font-black tracking-tight sm:text-4xl ${
          light ? 'text-white' : 'text-slate-900'
        }`}
      >
        {title}
      </h2>

      {description ? (
        <p
          className={`mt-4 text-base leading-7 ${
            light ? 'text-white/80' : 'text-slate-600/80'
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
}